exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".StarsBar__container__3lYXf{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;margin:0 -.2em}.StarsBar__star__3GwNh{-ms-flex:none;flex:none;width:1.4em;height:1em;padding:0 .2em}.StarsBar__star__3GwNh .StarsBar__starIcon__dbSXB{width:100%;height:100%}.StarsBar__starClickable__2mD0w{cursor:pointer}", "", {"version":3,"sources":["/mnt/d/asofts/vvs/cirrus/Cirrus/frontend/src/components/controls/src/components/controls/StarsBar.scss"],"names":[],"mappings":"AAAA,4BACI,oBAAa,AAAb,aAAa,AACb,sBAAmB,AAAnB,mBAAmB,AACnB,cAAgB,CACnB,AAED,uBACI,cAAU,AAAV,UAAU,AACV,YAAY,AACZ,WAAW,AACX,cAAgB,CAMnB,AAVD,kDAOQ,WAAW,AACX,WAAY,CACf,AAGL,gCACI,cAAe,CAClB","file":"StarsBar.scss","sourcesContent":[".container {\n    display: flex;\n    align-items: center;\n    margin: 0 -0.2em;\n}\n\n.star {\n    flex: none;\n    width: 1.4em;\n    height: 1em;\n    padding: 0 0.2em;\n\n    .starIcon {\n        width: 100%;\n        height: 100%;\n    }\n}\n\n.starClickable {\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "StarsBar__container__3lYXf",
	"star": "StarsBar__star__3GwNh",
	"starIcon": "StarsBar__starIcon__dbSXB",
	"starClickable": "StarsBar__starClickable__2mD0w"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/StarsBar.scss
// module id = ./node_modules/css-loader/index.js??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/StarsBar.scss
// module chunks = 0